import { render } from "./DeleteConfirmModal.vue?vue&type=template&id=20af01cb&scoped=true"
import script from "./DeleteConfirmModal.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmModal.vue?vue&type=script&lang=js"

import "./DeleteConfirmModal.vue?vue&type=style&index=0&id=20af01cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20af01cb"]])

export default __exports__